import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PAP } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-body',
  templateUrl: 'cerfa-body.component.html',
  styleUrls: ['./cerfa-body.component.less', '../../shared/common.less'],
})

export class CerfaBodyComponent implements OnInit {
  @Input() papValues: PAP;
  @Output() papValuesChange = new EventEmitter<PAP>();
  @Output() numberOfCollegesChanges = new EventEmitter<number>();
  @Output() toPollCreation = new EventEmitter<void>();

  needCerfa: boolean = true;

  constructor(
    private router: Router,
  ) {}

  onVenueChange(newVenue: any) {  
    this.papValues.venue = { ...this.papValues.venue, ...newVenue };
    this.papValuesChange.emit(this.papValues);
  }

  onContactChange(newContact: any) {
    this.papValues.contact = { ...newContact };
    this.papValuesChange.emit(this.papValues);
  }

  onSiretsChange(newSirets: any) {
    this.papValues.sirets = { ...newSirets };
    this.papValuesChange.emit(this.papValues);
  }

  onCommonListsChange(newCommonLists: any) {
    this.papValues.commonLists = [...newCommonLists];
    this.papValuesChange.emit(this.papValues);
  }

  onTermLengthChange(newTermLength: any) {
    this.papValues.termLength = { ...newTermLength };
    this.papValuesChange.emit(this.papValues);
  }

  onRoundChange(newRound: any) {
    this.papValues.round = { ...newRound };
    this.papValuesChange.emit(this.papValues);
  }
  
  onVenueChanges() {
    if (this.papValues.application.mailOption === false) {
      this.papValues.application.address = this.papValues.venue.address;
      this.papValues.application.zip = this.papValues.venue.zipcode;
      this.papValues.application.city = this.papValues.venue.city;
    }
    
    this.papValuesChange.emit(this.papValues);
  }

  onHeadcountChange(newHeadcount: any) {
    this.papValues.headcount = { ...newHeadcount };
    this.papValuesChange.emit(this.papValues);
  }

  onPapValuesChange() {
    this.papValuesChange.emit(this.papValues);
  }

  onNumberOfCollegesChanges() {
    this.numberOfCollegesChanges.emit(this.papValues.headcount.numberOfColleges);
  }

  goToPollCreation() {
    this.toPollCreation.emit();
  }
  
  ngOnInit(): void {
  }
}
